/* WSQ Theme — GSAP Scroll Animations */

window.addEventListener('load', () => {
  if (typeof gsap === 'undefined' || !window.__WSQ_ANIMATIONS__) return;

  gsap.registerPlugin(ScrollTrigger);

  /* Fade Up (default) */
  gsap.utils.toArray('[data-animate="fade-up"]').forEach(el => {
    gsap.to(el, {
      opacity: 1,
      y: 0,
      duration: 0.9,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: el,
        start: 'top 88%',
        toggleActions: 'play none none none',
      },
    });
  });

  /* Fade In */
  gsap.utils.toArray('[data-animate="fade-in"]').forEach(el => {
    gsap.to(el, {
      opacity: 1,
      duration: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: el,
        start: 'top 88%',
        toggleActions: 'play none none none',
      },
    });
  });

  /* Slide Left */
  gsap.utils.toArray('[data-animate="slide-left"]').forEach(el => {
    gsap.to(el, {
      opacity: 1,
      x: 0,
      duration: 0.9,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: el,
        start: 'top 88%',
        toggleActions: 'play none none none',
      },
    });
  });

  /* Slide Right */
  gsap.utils.toArray('[data-animate="slide-right"]').forEach(el => {
    gsap.to(el, {
      opacity: 1,
      x: 0,
      duration: 0.9,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: el,
        start: 'top 88%',
        toggleActions: 'play none none none',
      },
    });
  });

  /* Scale Up */
  gsap.utils.toArray('[data-animate="scale-up"]').forEach(el => {
    gsap.to(el, {
      opacity: 1,
      scale: 1,
      duration: 0.8,
      ease: 'back.out(1.2)',
      scrollTrigger: {
        trigger: el,
        start: 'top 88%',
        toggleActions: 'play none none none',
      },
    });
  });

  /* Staggered children — add data-animate-stagger to parent */
  gsap.utils.toArray('[data-animate-stagger]').forEach(parent => {
    const children = parent.children;
    gsap.fromTo(
      children,
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.12,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: parent,
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
      }
    );
  });

  /* Parallax hero image */
  const heroParallax = document.querySelector('[data-parallax]');
  if (heroParallax) {
    gsap.to(heroParallax, {
      yPercent: 25,
      ease: 'none',
      scrollTrigger: {
        trigger: heroParallax.closest('section'),
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      },
    });
  }

  /* Counter animation */
  gsap.utils.toArray('[data-counter]').forEach(el => {
    const target = parseFloat(el.dataset.counter);
    ScrollTrigger.create({
      trigger: el,
      start: 'top 85%',
      onEnter: () => {
        gsap.fromTo(
          { val: 0 },
          { val: target, duration: 2, ease: 'power2.out',
            onUpdate: function () {
              el.textContent = Math.round(this.targets()[0].val).toLocaleString();
            }
          }
        );
      },
      once: true,
    });
  });
});
